<div
  class="carousel"
  role="region"
  aria-roledescription="carousel"
  [attr.aria-label]="'main.promoCarouselLabel' | t"
  (mouseenter)="pause()"
  (mouseleave)="resume()"
  (focusin)="pause()"
  (focusout)="resume()"
>
  <div class="viewport">
    @for (slide of slides; track slide.titleKey; let i = $index) {
      <figure class="slide" [class.active]="i === current" [attr.aria-hidden]="i !== current">
        <img
          [src]="imageOf(slide)"
          [alt]="slide.titleKey | t"
          [attr.loading]="i === 0 ? 'eager' : 'lazy'"
        />
        <figcaption>
          <h3>{{ slide.titleKey | t }}</h3>
          <p>{{ slide.textKey | t }}</p>
        </figcaption>
      </figure>
    }
    <button type="button" class="arrow prev" (click)="previous()" [attr.aria-label]="'main.promoPrev' | t">
      ‹
    </button>
    <button type="button" class="arrow next" (click)="next()" [attr.aria-label]="'main.promoNext' | t">
      ›
    </button>
  </div>
  <div class="dots">
    @for (slide of slides; track slide.titleKey; let i = $index) {
      <button
        type="button"
        class="dot"
        [class.active]="i === current"
        [attr.aria-label]="'main.promoGoTo' | t: { n: i + 1 }"
        [attr.aria-current]="i === current"
        (click)="goTo(i)"
      ></button>
    }
  </div>
</div>
